module.exports = __webpack_public_path__ + "img/openchat1.e5503f97.png";